import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface EnrollmentManagementTemplateProps {
  readonly children: ReactNode;
}

export function EnrollmentManagementTemplate({ children }: EnrollmentManagementTemplateProps) {
  const { t } = useTranslation('personManagement');

  return (
    <div className="flex flex-col gap-xs">
      <Breadcrumb>
        <BreadcrumbLink>
          <Link to="/">
            <BreadcrumbIcon />
          </Link>
        </BreadcrumbLink>
        <BreadcrumbLink>
          <Link to="/enrollments">{t('breadcrumb.enrollments')}</Link>
        </BreadcrumbLink>
        <BreadcrumbPage>{t('breadcrumb.management')}</BreadcrumbPage>
      </Breadcrumb>

      {children}
    </div>
  );
}
